import React, { useState, useEffect } from 'react';

import { BaseSample } from '@vlabs/shared/components/sample/BaseSample';
import cn from 'classnames';
import PropTypes from 'prop-types';

import st from './MultiSample.module.sass';

export const MultiSample = ({
  primary = { type: 'face' },
  secondary = { type: 'body' },
  className = undefined,
  'data-testid': testId = undefined,
  sampleType = 'multi',
  mainSample = 'face',
}) => {
  const [mainView, setMainView] = useState('primary');

  useEffect(() => {
    if (!primary.imageUrl) {
      setMainView('secondary');
      return;
    }

    // если sampleType === 'multi' → mainSample определяет главную
    // если sampleType face/body → main определяется по sampleType
    if (sampleType === 'multi') {
      setMainView(mainSample === 'face' ? 'primary' : 'secondary');
    } else {
      setMainView(sampleType === 'face' ? 'primary' : 'secondary');
    }
  }, [primary, secondary, sampleType, mainSample]);

  const viewMap = {
    primary: {
      main: primary,
      inside: secondary,
    },
    secondary: {
      main: secondary,
      inside: primary,
    },
  };

  const onInsideImageClick = (e) => {
    e.stopPropagation();
    setMainView(mainView === 'primary' ? 'secondary' : 'primary');
  };

  return (
    <div className={cn(st.MultiSample, className)} data-testid={testId}>
      <div className={st.SampleContainer}>
        <div className={st.BackgroundSample} style={{ backgroundImage: `url(${viewMap[mainView].main?.imageUrl})` }} />
        <BaseSample
          className={st.Sample}
          emptyClassName={st.Empty}
          imageUrl={viewMap[mainView].main?.imageUrl}
          type={viewMap[mainView].main?.type ?? 'face'}
        />
      </div>

      {sampleType === 'multi' && viewMap[mainView].inside?.imageUrl && (
        <button
          aria-label="Toggle inside image"
          className={st.Toggle}
          onClick={onInsideImageClick}
          type="button"
        >
          <div className={st.BackgroundSample} style={{ backgroundImage: `url(${viewMap[mainView].inside.imageUrl})` }} />
          <BaseSample
            className={cn(st.Sample, st.Sample_inside)}
            emptyClassName={st.Empty_inside}
            imageUrl={viewMap[mainView].inside.imageUrl}
            type={viewMap[mainView].inside?.type ?? 'body'}
          />
        </button>
      )}
    </div>
  );
};

MultiSample.propTypes = {
  primary: PropTypes.shape({
    imageUrl: PropTypes.string,
    type: PropTypes.oneOf(['face', 'body']).isRequired,
  }),
  secondary: PropTypes.shape({
    imageUrl: PropTypes.string,
    type: PropTypes.oneOf(['face', 'body']).isRequired,
  }),
  className: PropTypes.string,
  'data-testid': PropTypes.string,
  sampleType: PropTypes.oneOf(['multi', 'face', 'body']),
  mainSample: PropTypes.oneOf(['face', 'body']),
};
